<template>
  <div class="order-form d-flex justify-content-center py-5 w-100">
    <b-card class="order-form-card bg-white" style="width: 600px" title="Order">
      <!-- subtitle -->
      <b-card-sub-title class="mb-2"
        >Use this form to order parts from Sea-Way Marine. Your order will be
        sent to a sales person and is processed in the normal
        way.</b-card-sub-title
      >
      <div class="font-weight-light text-secondary p-2">
        Note: When adding Mercury Part numbers please do not add the dash sign
        or any spaces. Example part 26-F40307-2 should be entered 26F403072.
        This rule applies to Mercury parts only.
      </div>
      <!-- part input -->
      <order-input></order-input>
      <!-- order items -->
      <order-items-container class></order-items-container>
      <!-- note input  -->
      <div
        class="mb-4 d-flex flex-row justify-content-between align-items-center border rounded p-2 mt-4"
      >
        <p class="m-3">Note:</p>
        <b-form-textarea
          placeholder="(optional)"
          rows="1"
          v-model="note"
        ></b-form-textarea>
      </div>
      <!-- order details -->
      <div
        class="m-1 d-flex flex-row justify-content-between align-items-center border rounded p-2 mt-4"
      >
        <div class="d-flex flex-column">
          <p class="m-0">{{ `subtotal: $${cost.toFixed(2)}` }}</p>

          <p class="m-0">{{ `total: $${cost.toFixed(2)}` }}</p>
          <p class="m-0">shipping: *contact</p>
        </div>
        <div>
          <b-form-checkbox v-model="pickup">Will Call</b-form-checkbox>
          <b-btn :disabled="submitting" variant="success" @click="submit"
            >Submit order</b-btn
          >
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import OrderItemsContainer from "@/components/OrderItemsContainer";
import OrderInput from "@/components/OrderInput";
import { mapGetters } from "vuex";
export default {
  name: "order-view",
  components: {
    OrderInput,
    OrderItemsContainer,
  },
  mounted() {
    this.$store.commit("order/resetState");
  },
  data() {
    return {
      submitting: false,
    };
  },
  methods: {
    submit() {
      this.$data.submitting = true;
      this.$store
        .dispatch("order/submitOrder")
        .then(() => {
          this.$router.push("/confirmation");
          
        })
        .catch((err) => {
          alert(err);
           this.$data.submitting = false;
        });
    },
  },
  computed: {
    pickup: {
      get() {
        return this.$store.state.order.pickup;
      },
      set(val) {
        this.$store.commit("order/updatePickup", val);
      },
    },
    note: {
      get() {
        return this.$store.state.order.note;
      },
      set(val) {
        this.$store.commit("order/updateNote", val);
      },
    },
    cost() {
      return Object.keys(this.items).reduce(
        (acc, cur) =>
          acc + this.items[cur].retail_price * this.items[cur].orderQuantity,
        0
      );
    },
    salesTax() {
      return this.cost * 0.105;
    },
    ...mapGetters("order", ["items"]),
  },
};
</script>

<style lang="scss" scoped>
</style>
